// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"95a13b2a","453":"5426d677","455":"1ba83e64","672":"c6762a10","725":"f4315b1c","741":"f703ec3f","894":"e17a7396","977":"87456b24"}[chunkId] + ".chunk.js";
};